module.exports = __webpack_public_path__ + "static/media/bg_19.eb4cc5ec.png";